<div [ngClass]="{'background-image': isSuccess}">
    <div class="avatar-personal-details flex-centered-container margin-top">
        <img src="/assets/icons/logo-compact.png">
    </div>

    <div *ngIf="isUnsubscribe">
        <div class="pad-32-hr flex-centered-container-hr-column margin-8-top text-center">
            <div class="font-16 font-bold">
                <span *ngIf="!downgrade">Unsubscribe Plan</span>
                <span *ngIf="downgrade">
                    <mat-icon class="warning-logo text-neutral">warning</mat-icon>
                </span>
            </div>
            <div class="margin-top">
                {{PLAN_UNSUBSCRIBE}}
            </div>
            <div class="dashed-line border-dashed-top margin"></div>

            <div class="flex-space-between margin-bottom font-12 pad-32-hr">
                <span>Current Plan</span>
                <span>{{planName}}</span>
            </div>

            <div class="flex-space-between margin-bottom font-12 pad-32-hr">
                <span>Valid till</span>
                <span>{{validity}}</span>
            </div>

            <div class="margin-top"> 
                <span *ngIf="!downgrade">Are you sure you want to cancel your subscription?</span>
                <span *ngIf="downgrade">Do you want to proceed?</span>
            </div>
            <div class="flex-space-between">
                <button mat-flat-button color="accent" (click)="closeDialog()"
                    class="ut-pro-button margin-top width-40 pad-4 gradient border-radius-8 margin-left-24">
                    No
                </button>
                <button mat-flat-button color="accent" (click)="closeDialog(true)"
                    class="ut-pro-button margin-top pad-4 width-40 gradient-warn border-radius-8 margin-24-right">
                    Yes
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="isSuccess && !downgrade">
        <div class="flex-centered-container margin-24-top">
            <img class="success-logo pad-8-right" src="/assets/images/payment_success.png">
            <span class="font-16 font-bold">Payment Completed</span>
        </div>

        <div class="flex-centered-container-hr-column align-items-center margin-24-top">
            <div>
                Paid Amount
            </div>
            <div class="margin-8-top font-26 font-bold">
                ₹ {{amount}}
            </div>
        </div>
        <div class="dashed-line border-dashed-top"></div>
        <span class="flex-centered-container-hr margin-top">Plan upgraded to
            <span class="plans-text pad-4-left">{{planName}}</span></span>
    </div>
</div>